var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isRouter
    ? _c(
        "router-link",
        {
          staticClass: "square-button",
          class: { "is-active": _vm.isActive, "is-light": !_vm.isDark },
          style: { color: _vm.fontColor },
          attrs: { to: _vm.to, tag: "div" },
          nativeOn: {
            click: function($event) {
              return _vm.onClick($event)
            }
          }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.showBadge && _vm.notification > 0
            ? _c("span", { staticClass: "square-button__badge" }, [
                _vm._v(_vm._s(_vm.notificationCount))
              ])
            : _vm._e()
        ],
        2
      )
    : _c(
        "a",
        {
          staticClass: "square-button",
          class: { "is-active": _vm.isActive, "is-light": !_vm.isDark },
          attrs: { href: "#" },
          on: { click: _vm.onClick }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.showBadge && _vm.notification > 0
            ? _c("span", { staticClass: "square-button__badge" }, [
                _vm._v("\n        " + _vm._s(_vm.notificationCount) + "\n    ")
              ])
            : _vm._e()
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }